import useTranslate from "ui/locale/hooks/useTranslate";
import useGetTransactionsStats from "features/transactions/hooks/useGetTransactionStats";
import { UseTransactionsChartReturn } from "../TransactionsChart.types";

export default function useTransactionsChart(): UseTransactionsChartReturn {
    const translate = useTranslate();
    const { data: stats, isLoading } = useGetTransactionsStats();

    return { title: translate("transactions"), stats, isLoading };
}
